const SEARCH_SCOPES = ["all", "op"] as const;

export type SearchScope = (typeof SEARCH_SCOPES)[number];

/** URLの未知値を、既存検索と互換の全文検索へ正規化する。 */
export function normalizeSearchScope(value: unknown): SearchScope {
  return value === "op" ? "op" : "all";
}

/** 既定値allはURLから省略し、非既定の選択だけを共有可能にする。 */
export function serializeSearchScope(scope: SearchScope): "op" | undefined {
  return scope === "op" ? "op" : undefined;
}
